export const SET_LOOKBOOK = 'SET_LOOKBOOK';
export const SET_LOADING_AMBIENCES = 'SET_LOADING_AMBIENCES';
export const APPEND_AMBIENCES = 'APPEND_AMBIENCES';
export const PREPEND_AMBIENCES = 'PREPEND_AMBIENCES';